/* Wrinkless premium pages: header, menu, reveal, gallery, pack picker, add to cart. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  // Header gets a hairline once the page scrolls
  const header = $('.wx-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Announcement bar: one message at a time
  $$('[data-wx-rotate]').forEach((rot) => {
    const items = $$('span', rot);
    if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 3500);
  });

  // Mobile menu
  const nav = $('.wx-mobile-nav');
  $$('[data-wx-menu-open]').forEach((b) => b.addEventListener('click', () => { nav?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
  $$('[data-wx-menu-close], .wx-mobile-nav a').forEach((b) => b.addEventListener('click', () => { nav?.classList.remove('is-open'); document.body.style.overflow = ''; }));

  // Fade sections in as they scroll into view
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('.wx-reveal').forEach((el) => io.observe(el));
  } else {
    $$('.wx-reveal').forEach((el) => el.classList.add('is-in'));
  }

  // Product gallery
  $$('.wx-gallery').forEach((g) => {
    const slides = $$('.wx-gallery__slide', g);
    const thumbs = $$('.wx-gallery__thumbs button', g);
    const show = (i) => {
      slides.forEach((s, j) => {
        s.classList.toggle('is-active', i === j);
        const v = s.querySelector('video');
        if (v) { if (i === j) { v.muted = true; v.preload = 'auto'; v.play().catch(() => { v.controls = true; }); } else { v.pause(); } }
      });
      thumbs.forEach((t, j) => { t.classList.toggle('is-active', i === j); t.setAttribute('aria-current', i === j); });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    // jump to the photo tagged with the picked pack; back to the first photo when leaving it
    document.addEventListener('wx:pack', (e) => {
      const i = slides.findIndex((s) => s.dataset.wxPack === e.detail);
      if (i >= 0) show(i);
      else if (slides.find((s) => s.classList.contains('is-active'))?.dataset.wxPack) show(0);
    });
    // swipe on touch screens
    let x0 = null, cur = 0;
    const main = $('.wx-gallery__main', g);
    main?.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; cur = slides.findIndex((s) => s.classList.contains('is-active')); }, { passive: true });
    main?.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      x0 = null;
    });
  });

  // Pack picker + add to cart (opens the theme's cart drawer)
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  $$('[data-wx-buy]').forEach((form) => {
    const button = $('[data-wx-add]', form);
    const label = $('[data-wx-add-label]', form);
    const error = $('.wx-error', form);
    const sync = () => {
      const picked = $('input[name="id"]:checked', form);
      if (!picked || !label) return;
      if (form.querySelector('.wx-packs')) label.textContent = `Add to cart · ${money(+picked.dataset.price)}`;
      if (!form.querySelector('.wx-packs')) return;
      $$('[data-wx-price]').forEach((el) => { el.textContent = money(+picked.dataset.price); });
      $$('[data-wx-sticky-pack]').forEach((el) => { el.textContent = picked.dataset.title; });
      const url = new URL(location.href);
      if (form.hasAttribute('data-wx-update-url')) { url.searchParams.set('variant', picked.value); history.replaceState(null, '', url); }
    };
    form.addEventListener('change', () => {
      sync();
      document.dispatchEvent(new CustomEvent('wx:pack', { detail: $('input[name="id"]:checked', form)?.dataset.title }));
    });
    sync();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const picked = $('input[name="id"]:checked', form);
      if (!picked) return;
      button.disabled = true;
      if (error) error.textContent = '';
      const drawer = document.querySelector('cart-drawer');
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: +picked.value, quantity: 1 }],
            sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
            sections_url: location.pathname,
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        if (drawer && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...data, id: data.items?.[0]?.product_id, sections: data.sections });
        } else {
          location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        }
      } catch (err) {
        if (error) error.textContent = err.message;
      } finally {
        button.disabled = false;
      }
    });
  });

  // "Read more" only on review cards whose text is cut off
  $$('[data-wx-clamp]').forEach((body) => {
    const more = body.nextElementSibling;
    if (!more?.hasAttribute('data-wx-more')) return;
    if (body.scrollHeight > body.clientHeight + 4) more.hidden = false;
    more.addEventListener('click', () => {
      const open = body.classList.toggle('is-open');
      more.textContent = open ? 'Show less' : 'Read more';
    });
  });

  // Review card arrows
  $$('[data-wx-scroll]').forEach((b) => b.addEventListener('click', () => {
    const track = b.closest('section')?.querySelector('[data-wx-track]');
    const card = track?.firstElementChild;
    if (track && card) track.scrollBy({ left: (+b.dataset.wxScroll) * (card.getBoundingClientRect().width + 16), behavior: 'smooth' });
  }));

  // Sticky bars appear once the page's own buy button is off screen (product page on phones:
  // after a short scroll, so the title shows cleanly first), and step aside while the shop
  // cards, the closing call to action or the footer are on screen, so buttons never double up.
  const phone = matchMedia('(max-width: 899px)');
  const bars = [
    { bar: $('.wx-sticky-buy:not(.wx-sticky-shop)'), trigger: $('[data-wx-main-buy]'), early: true },
    { bar: $('[data-wx-sticky-shop]'), trigger: $('[data-wx-hero-cta]'), phoneOnly: true },
  ].filter((s) => s.bar && s.trigger);
  if (bars.length && 'IntersectionObserver' in window) {
    const quiet = new Set();
    const update = () => bars.forEach((s) => {
      const past = !s.inView && (s.above || (s.early && phone.matches && window.scrollY > 120));
      s.bar.classList.toggle('is-visible', (!s.phoneOnly || phone.matches) && past && !quiet.size);
    });
    bars.forEach((s) => new IntersectionObserver(([e]) => {
      s.inView = e.isIntersecting; s.above = e.boundingClientRect.top < 0; update();
    }).observe(s.trigger));
    const zones = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? quiet.add(e.target) : quiet.delete(e.target)));
      update();
    });
    $$('.wx-shop, .wx-cta, .wx-footer').forEach((el) => zones.observe(el));
    window.addEventListener('scroll', update, { passive: true });
    $('[data-wx-sticky-add]')?.addEventListener('click', () => $('[data-wx-main-buy] [data-wx-add]')?.click());
  }
})();
